import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { SimilarParagraphSet } from '../../../generated/graphql-models';
import { ApiRoutes } from '../../shared/constants/routes';
import { GraphQLService } from '../../shared/services/graphql.service';
import {
  GET_ALL_SYNONYM_CLASSES,
  GET_DEFINED_TERMS_FOR_ORGANIZER,
  GET_SIMILAR_DEFINED_TERMS,
  GET_SYNONYM_CLASSES,
  SET_DEFINED_TERM_IGNORE,
} from '../constants/term-synonym-organizer.queries';
import { DefinedTermItem, SimilarDefinedTerm } from '../models/defined-term.model';

interface OperationResponse {
  isSucceeded: boolean;
}

export interface FilterParagraphsRequest {
  assetShortName: string;
  termDefined?: string;
  limit?: number;
}

@Injectable({ providedIn: 'root' })
export class TermSynonymOrganizerService {
  private readonly graphQlService = inject(GraphQLService);
  private readonly http = inject(HttpClient);

  public getAllDefinedTerms(assetShortName?: string): Observable<DefinedTermItem[]> {
    return this.graphQlService.getManyQuery<DefinedTermItem, { assetShortName?: string }>(
      GET_DEFINED_TERMS_FOR_ORGANIZER,
      { assetShortName }
    );
  }

  public setIgnore(id: string, ignore: boolean): Observable<OperationResponse> {
    return this.graphQlService.mutate<OperationResponse, { id: string; ignore: boolean }>(SET_DEFINED_TERM_IGNORE, {
      id,
      ignore,
    });
  }

  public getSimilarDefinedTerms(
    assetShortName: string,
    definedTerm: string,
    limit?: number
  ): Observable<SimilarDefinedTerm[]> {
    return this.graphQlService.getManyQuery<
      SimilarDefinedTerm,
      { assetShortName: string; definedTerm: string; limit?: number }
    >(GET_SIMILAR_DEFINED_TERMS, { assetShortName, definedTerm, limit });
  }

  public getSynonymClasses(assetShortName: string): Observable<string[][]> {
    return this.graphQlService.getSingleQuery<string[][], { assetShortName: string }>(GET_SYNONYM_CLASSES, {
      assetShortName,
    });
  }

  public getAllSynonymClasses(): Observable<SynonymClassesByAsset[]> {
    return this.graphQlService.getManyQuery<SynonymClassesByAsset, Record<string, never>>(GET_ALL_SYNONYM_CLASSES, {});
  }

  public filterParagraphs(body: FilterParagraphsRequest): Observable<SimilarParagraphSet> {
    return this.http.post<SimilarParagraphSet>(ApiRoutes.paragraphs.filter(), body);
  }
}

export interface SynonymClassesByAsset {
  assetShortName: string;
  synonymClasses: string[][];
}
